import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";

export default function ExpertProfileSection({ sectionTitle, sectionTitleUp, data }) {
  const item = data[0]; // Assuming only one expert (Dr. Archana) is passed in for About page
  
  return (
    <section className="cs_about_new_expert">
      <div className="container">
        <div className="text-center cs_expert_header">
          {sectionTitleUp && <h6 className="cs_section_subtitle">{sectionTitleUp}</h6>}
          {sectionTitle && <h2>{sectionTitle}</h2>}
        </div>
        
        <div className="cs_expert_row">
          <div className="cs_expert_img_col">
            <div className="cs_arch_img_container">
              <img src={item.imgUrl} alt={item.name} />
            </div>
          </div>
          
          <div className="cs_expert_content_col">
            <h3 className="cs_expert_name">{item.name}</h3>
            
            {item.social && (
              <div className="cs_expert_social">
                {item.social.map((socialItem, idx) => (
                  <Link to={socialItem.href} key={idx} target="_blank" rel="noopener noreferrer">
                    <Icon icon={socialItem.icon} />
                  </Link>
                ))}
              </div>
            )}
            
            <div className="cs_expert_details_card">
              <div className="cs_expert_detail_row">
                <Icon icon="mdi:certificate-outline" className="cs_detail_icon" />
                <div>
                  <span className="cs_detail_label">QUALIFICATION</span>
                  <span className="cs_detail_value">{item.designation}</span>
                </div>
              </div>
              <div className="cs_expert_detail_row">
                <Icon icon="mdi:briefcase-outline" className="cs_detail_icon" />
                <div>
                  <span className="cs_detail_label">EXPERIENCE</span>
                  <span className="cs_detail_value">24 Years of Experience</span>
                </div>
              </div>
              <div className="cs_expert_detail_row">
                <Icon icon="mdi:hospital-building" className="cs_detail_icon" />
                <div>
                  <span className="cs_detail_label">POSITION</span>
                  <span className="cs_detail_value">Director, Pluro Jabalpur Fertility Center</span>
                </div>
              </div>
            </div>
            
            <div className="cs_expert_description">
              <p>{item.description}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
